import type { ReactElement } from 'react';
import { Icon } from '@pixum/icon';
import { PAYMENT_METHOD, PAYMENT_METHOD_ICON_NAME } from '../../payment/constants';
import type { CartPaymentOption } from '../../payment/types';
import { getCreditCardIcon } from './getCreditCardIcon';

/** Decorative: ToggleCard hides the topRight slot from assistive technology. */
export function getPaymentIcons(option: CartPaymentOption): ReactElement[] {
  if (option.method === PAYMENT_METHOD.CREDIT_CARD) {
    return option.types.map(getCreditCardIcon);
  }

  const name = PAYMENT_METHOD_ICON_NAME[option.method];

  // Brand logos keep their own colours, so no CSS mask.
  return name ? [<Icon key={name} name={name} useMask={false} ariaHidden size="large" />] : [];
}
